import { useEffect } from 'react';
import { useFirstClientMount } from '@hooks/useFirstClientMount';
import { observer } from 'mobx-react-lite';

export const FirstClientMountDefiner = observer(() => {
  const { setIsFirstClientMount } = useFirstClientMount();

  useEffect(() => {
    setIsFirstClientMount(false);
  }, []);

  return null;
});
